import { StateReducers }  from 'state/reducers/types/StateReducers'

interface Props {
  state: StateReducers
}

export const getQueryInviteId = ({ state }: Props): string | undefined => {
  return state.currentLocation?.query?.inviteId
}
